import React from "react";
import { CheckCircle2, AlertOctagon, AlertTriangle, FlaskConical, Circle, HelpCircle } from "lucide-react";

// Triple-encoded status: icon + shape/border + text label + color. Never color alone.
const MAP = {
  PASS: { icon: CheckCircle2, cls: "border-emerald-500 bg-emerald-950/40 text-emerald-200", label: "PASS" },
  Passed: { icon: CheckCircle2, cls: "border-emerald-500 bg-emerald-950/40 text-emerald-200", label: "PASS" },
  READY: { icon: CheckCircle2, cls: "border-emerald-500 bg-emerald-950/40 text-emerald-200", label: "READY" },
  Connected: { icon: CheckCircle2, cls: "border-emerald-500 bg-emerald-950/40 text-emerald-200", label: "CONNECTED" },
  Healthy: { icon: CheckCircle2, cls: "border-emerald-500 bg-emerald-950/40 text-emerald-200", label: "HEALTHY" },
  Approved: { icon: CheckCircle2, cls: "border-emerald-500 bg-emerald-950/40 text-emerald-200", label: "APPROVED" },
  FAIL: { icon: AlertOctagon, cls: "border-red-500 bg-red-950/40 text-red-200", label: "FAIL" },
  Critical: { icon: AlertOctagon, cls: "border-red-500 bg-red-950/40 text-red-200", label: "CRITICAL" },
  CRITICAL: { icon: AlertOctagon, cls: "border-red-500 bg-red-950/40 text-red-200", label: "CRITICAL" },
  "NOT READY": { icon: AlertOctagon, cls: "border-red-500 bg-red-950/40 text-red-200", label: "NOT READY" },
  High: { icon: AlertTriangle, cls: "border-orange-500 bg-orange-950/40 text-orange-200", label: "HIGH" },
  HIGH: { icon: AlertTriangle, cls: "border-orange-500 bg-orange-950/40 text-orange-200", label: "HIGH" },
  "REQUIRES WORK": { icon: AlertTriangle, cls: "border-orange-500 bg-orange-950/40 text-orange-200", label: "REQUIRES WORK" },
  Partial: { icon: AlertTriangle, cls: "border-amber-500 bg-amber-950/40 text-amber-200", label: "PARTIAL" },
  Medium: { icon: AlertTriangle, cls: "border-amber-500 bg-amber-950/40 text-amber-200", label: "MEDIUM" },
  STANDARD: { icon: AlertTriangle, cls: "border-amber-500 bg-amber-950/40 text-amber-200", label: "STANDARD" },
  Warning: { icon: AlertTriangle, cls: "border-amber-500 bg-amber-950/40 text-amber-200", label: "RISK" },
  "PARTIALLY READY": { icon: AlertTriangle, cls: "border-amber-500 bg-amber-950/40 text-amber-200", label: "PARTIALLY READY" },
  Low: { icon: Circle, cls: "border-sky-500 bg-sky-950/40 text-sky-200", label: "LOW" },
  LOW: { icon: Circle, cls: "border-sky-500 bg-sky-950/40 text-sky-200", label: "LOW" },
  SIMULATION: { icon: FlaskConical, cls: "border-blue-500 bg-blue-950/40 text-blue-200", label: "SIMULATION" },
  SIMULATED: { icon: FlaskConical, cls: "border-blue-500 bg-blue-950/40 text-blue-200", label: "SIMULATED" },
  DEMO: { icon: FlaskConical, cls: "border-blue-500 bg-blue-950/40 text-blue-200", label: "DEMO" },
  OBSERVED: { icon: CheckCircle2, cls: "border-emerald-500 bg-emerald-950/40 text-emerald-200", label: "OBSERVED" },
  "NOT ASSESSED": { icon: HelpCircle, cls: "border-slate-500 bg-slate-800/50 text-slate-300", label: "NOT ASSESSED" },
};

export default function StatusBadge({ value, testId }) {
  const cfg = MAP[value] || { icon: Circle, cls: "border-slate-500 bg-slate-800/50 text-slate-300", label: String(value || "—").toUpperCase() };
  const Icon = cfg.icon;
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1.5 rounded-lg border-2 px-2 py-0.5 text-xs font-semibold ${cfg.cls}`}>
      <Icon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
      <span>{cfg.label}</span>
    </span>
  );
}
